import { render, staticRenderFns } from "./DetailsPage.vue?vue&type=template&id=1c067e64&scoped=true"
import script from "./DetailsPage.vue?vue&type=script&lang=js"
export * from "./DetailsPage.vue?vue&type=script&lang=js"
import style0 from "./DetailsPage.vue?vue&type=style&index=0&id=1c067e64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c067e64",
  null
  
)

export default component.exports